import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type InitializeOrderMutationVariables = Types.Exact<{
  input: Types.InitializeOrderInput;
}>;


export type InitializeOrderMutation = { __typename?: 'Mutation', initializeOrder: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type DeleteOrderMutationVariables = Types.Exact<{
  input: Types.DeleteOrderInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreditExistingOrderMutationVariables = Types.Exact<{
  input: Types.CreditExistingOrderInput;
}>;


export type CreditExistingOrderMutation = { __typename?: 'Mutation', creditExistingOrder: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, stageResult?: { __typename?: 'OrderWriteStageResultData', outcome: Types.OrderWriteOutcome, orderId?: string | null, stages: Array<{ __typename?: 'OrderWriteStageStatusData', stage: Types.OrderWriteStage, status: Types.OrderWriteStageStatus }> } | null } };

export type RecordOrderDepositMutationVariables = Types.Exact<{
  input: Types.RecordOrderDepositInput;
}>;


export type RecordOrderDepositMutation = { __typename?: 'Mutation', recordOrderDeposit: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type EditOrderMutationVariables = Types.Exact<{
  input: Types.EditOrderInput;
}>;


export type EditOrderMutation = { __typename?: 'Mutation', editOrder: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type AddOrderFlatChargeMutationVariables = Types.Exact<{
  input: Types.AddOrderFlatChargeInput;
}>;


export type AddOrderFlatChargeMutation = { __typename?: 'Mutation', addOrderFlatCharge: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type EditOrderFlatChargeMutationVariables = Types.Exact<{
  input: Types.EditOrderFlatChargeInput;
}>;


export type EditOrderFlatChargeMutation = { __typename?: 'Mutation', editOrderFlatCharge: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RemoveOrderFlatChargeMutationVariables = Types.Exact<{
  input: Types.RemoveOrderFlatChargeInput;
}>;


export type RemoveOrderFlatChargeMutation = { __typename?: 'Mutation', removeOrderFlatCharge: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderQuoteDetailsMutationVariables = Types.Exact<{
  input: Types.SetOrderQuoteDetailsInput;
}>;


export type SetOrderQuoteDetailsMutation = { __typename?: 'Mutation', setOrderQuoteDetails: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', orderId: string, status: Types.OrderStatus, quoteValidUntil?: string | null, followUp?: { __typename?: 'OrderQuoteFollowUpData', on: string, note?: string | null, assignee: string, done: boolean, setBy: string, setAt: Types.TDateISO } | null } | null } };

export type SetOrderShipFromSiteMutationVariables = Types.Exact<{
  input: Types.SetOrderShipFromSiteInput;
}>;


export type SetOrderShipFromSiteMutation = { __typename?: 'Mutation', setOrderShipFromSite: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderPlannedShipDateMutationVariables = Types.Exact<{
  input: Types.SetOrderPlannedShipDateInput;
}>;


export type SetOrderPlannedShipDateMutation = { __typename?: 'Mutation', setOrderPlannedShipDate: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderContainerMutationVariables = Types.Exact<{
  input: Types.SetOrderContainerInput;
}>;


export type SetOrderContainerMutation = { __typename?: 'Mutation', setOrderContainer: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type AddLineItemsMutationVariables = Types.Exact<{
  input: Types.AddLineItemsInput;
}>;


export type AddLineItemsMutation = { __typename?: 'Mutation', addLineItems: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type AddLineItemsWithPricingMutationVariables = Types.Exact<{
  input: Types.AddLineItemsWithPricingInput;
}>;


export type AddLineItemsWithPricingMutation = { __typename?: 'Mutation', addLineItemsWithPricing: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateLineItemMutationVariables = Types.Exact<{
  input: Types.UpdateLineItemInput;
}>;


export type UpdateLineItemMutation = { __typename?: 'Mutation', updateLineItem: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetLineItemShippingUomMutationVariables = Types.Exact<{
  input: Types.SetLineItemShippingUomInput;
}>;


export type SetLineItemShippingUomMutation = { __typename?: 'Mutation', setLineItemShippingUom: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RepriceOrderLineMutationVariables = Types.Exact<{
  input: Types.RepriceOrderLineInput;
}>;


export type RepriceOrderLineMutation = { __typename?: 'Mutation', repriceOrderLine: { __typename?: 'RepriceOrderLinePayload', outcome?: Types.RepriceOrderLineOutcome | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, lineItem?: { __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> } | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RepriceOrderMutationVariables = Types.Exact<{
  input: Types.RepriceOrderInput;
}>;


export type RepriceOrderMutation = { __typename?: 'Mutation', repriceOrder: { __typename?: 'RepriceOrderPayload', repricedLineCount?: number | null, skippedOverrideLineCount?: number | null, unchangedLineCount?: number | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetLineItemCustomerItemMutationVariables = Types.Exact<{
  input: Types.SetLineItemCustomerItemInput;
}>;


export type SetLineItemCustomerItemMutation = { __typename?: 'Mutation', setLineItemCustomerItem: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetLineItemOverridePriceMutationVariables = Types.Exact<{
  input: Types.SetLineItemOverridePriceInput;
}>;


export type SetLineItemOverridePriceMutation = { __typename?: 'Mutation', setLineItemOverridePrice: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RemoveLineItemMutationVariables = Types.Exact<{
  input: Types.RemoveLineItemInput;
}>;


export type RemoveLineItemMutation = { __typename?: 'Mutation', removeLineItem: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateOrderContactMutationVariables = Types.Exact<{
  input: Types.UpdateOrderContactInput;
}>;


export type UpdateOrderContactMutation = { __typename?: 'Mutation', updateOrderContact: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateOrderStatusMutationVariables = Types.Exact<{
  input: Types.UpdateOrderStatusInput;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'Mutation', updateOrderStatus: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UnshipOrderMutationVariables = Types.Exact<{
  input: Types.UnshipOrderInput;
}>;


export type UnshipOrderMutation = { __typename?: 'Mutation', unshipOrder: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type ResetOrderSyncStatusMutationVariables = Types.Exact<{
  input: Types.ResetSyncStatusInput;
}>;


export type ResetOrderSyncStatusMutation = { __typename?: 'Mutation', resetOrderSyncStatus: Array<{ __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null }> };

export type UpdateSalesPersonMutationVariables = Types.Exact<{
  input: Types.UpdateSalesPersonInput;
}>;


export type UpdateSalesPersonMutation = { __typename?: 'Mutation', updateSalesPerson: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateAndGetNextOrderNumberMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type UpdateAndGetNextOrderNumberMutation = { __typename?: 'Mutation', updateAndGetNextOrderNumber: { __typename?: 'NextOrderNumberPayload', nextOrderNumber: number } };

export type UpdateAcknowledgedQuantityMutationVariables = Types.Exact<{
  input: Types.UpdateAcknowledgedQuantityItemsInput;
}>;


export type UpdateAcknowledgedQuantityMutation = { __typename?: 'Mutation', updateAcknowledgedQuantity: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type CorrectAcknowledgedQuantityMutationVariables = Types.Exact<{
  input: Types.CorrectAcknowledgedQuantityItemsInput;
}>;


export type CorrectAcknowledgedQuantityMutation = { __typename?: 'Mutation', correctAcknowledgedQuantity: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateShippedQuantityMutationVariables = Types.Exact<{
  input: Types.UpdateShippedQuantityItemsInput;
}>;


export type UpdateShippedQuantityMutation = { __typename?: 'Mutation', updateShippedQuantity: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type AllocateLineItemsMutationVariables = Types.Exact<{
  input: Types.AllocateLineItemsInput;
}>;


export type AllocateLineItemsMutation = { __typename?: 'Mutation', allocateLineItems: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, warnings?: Array<{ __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type BulkAllocateOrdersMutationVariables = Types.Exact<{
  input: Types.BulkAllocateOrdersInput;
}>;


export type BulkAllocateOrdersMutation = { __typename?: 'Mutation', bulkAllocateOrders: { __typename?: 'BulkAllocateOrdersPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, results: Array<{ __typename?: 'BulkAllocateOrderResult', orderId: string, outcome: Types.BulkAllocateOutcome, linesAllocated: number, skipReason?: Types.BulkAllocateSkipReason | null, message?: string | null, shortfalls: Array<{ __typename?: 'BulkAllocateLineShortfall', lineItemId: string, itemId: string, orderedQuantity: number, allocatedQuantity: number, shortByQuantity: number, shippingUomLabel?: string | null, orderedUnits?: number | null, allocatedUnits?: number | null, shortByUnits?: number | null }>, skippedLines: Array<{ __typename?: 'BulkAllocateSkippedLine', lineItemId: string, itemId: string, reason: Types.BulkAllocateLineSkipReason }>, warnings: Array<{ __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number }> }> } };

export type RemoveLineItemAllocationsMutationVariables = Types.Exact<{
  input: Types.RemoveLineItemAllocationsInput;
}>;


export type RemoveLineItemAllocationsMutation = { __typename?: 'Mutation', removeLineItemAllocations: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateLineItemContextNoteMutationVariables = Types.Exact<{
  input: Types.UpdateLineItemContextNoteInput;
}>;


export type UpdateLineItemContextNoteMutation = { __typename?: 'Mutation', updateLineItemContextNote: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type UpdateOrderSendOrderEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateOrderSendOrderEmailsInput;
}>;


export type UpdateOrderSendOrderEmailsMutation = { __typename?: 'Mutation', updateOrderSendOrderEmails: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderSendInvoiceEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateOrderSendInvoiceEmailsInput;
}>;


export type UpdateOrderSendInvoiceEmailsMutation = { __typename?: 'Mutation', updateOrderSendInvoiceEmails: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderRouteMutationVariables = Types.Exact<{
  input: Types.UpdateRouteInput;
}>;


export type UpdateOrderRouteMutation = { __typename?: 'Mutation', updateOrderRoute: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CorrectOrderMutationVariables = Types.Exact<{
  input: Types.CorrectOrderInput;
}>;


export type CorrectOrderMutation = { __typename?: 'Mutation', correctOrder: { __typename?: 'CorrectOrderPayload', order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, creditOrder?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddOrderLineUpgradeMutationVariables = Types.Exact<{
  input: Types.AddOrderLineUpgradeInput;
}>;


export type AddOrderLineUpgradeMutation = { __typename?: 'Mutation', addOrderLineUpgrade: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RemoveOrderLineUpgradeMutationVariables = Types.Exact<{
  input: Types.RemoveOrderLineUpgradeInput;
}>;


export type RemoveOrderLineUpgradeMutation = { __typename?: 'Mutation', removeOrderLineUpgrade: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type OverrideOrderLineUpgradePricingMutationVariables = Types.Exact<{
  input: Types.OverrideOrderLineUpgradePricingInput;
}>;


export type OverrideOrderLineUpgradePricingMutation = { __typename?: 'Mutation', overrideOrderLineUpgradePricing: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderNoteMutationVariables = Types.Exact<{
  input: Types.SetOrderNoteInput;
}>;


export type SetOrderNoteMutation = { __typename?: 'Mutation', setOrderNote: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type ClearOrderNoteMutationVariables = Types.Exact<{
  input: Types.ClearOrderNoteInput;
}>;


export type ClearOrderNoteMutation = { __typename?: 'Mutation', clearOrderNote: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderNoTaxMutationVariables = Types.Exact<{
  input: Types.SetOrderNoTaxInput;
}>;


export type SetOrderNoTaxMutation = { __typename?: 'Mutation', setOrderNoTax: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type ClearOrderNoTaxMutationVariables = Types.Exact<{
  input: Types.ClearOrderNoTaxInput;
}>;


export type ClearOrderNoTaxMutation = { __typename?: 'Mutation', clearOrderNoTax: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type SetOrderDropShipDestinationMutationVariables = Types.Exact<{
  input: Types.SetOrderDropShipDestinationInput;
}>;


export type SetOrderDropShipDestinationMutation = { __typename?: 'Mutation', setOrderDropShipDestination: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type ClearOrderDropShipDestinationMutationVariables = Types.Exact<{
  input: Types.ClearOrderDropShipDestinationInput;
}>;


export type ClearOrderDropShipDestinationMutation = { __typename?: 'Mutation', clearOrderDropShipDestination: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type RefreshOrderTaxEstimateMutationVariables = Types.Exact<{
  input: Types.RefreshOrderTaxEstimateInput;
}>;


export type RefreshOrderTaxEstimateMutation = { __typename?: 'Mutation', refreshOrderTaxEstimate: { __typename?: 'RefreshOrderTaxEstimatePayload', estimate?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ImportOrdersMutationVariables = Types.Exact<{
  input: Types.ImportOrdersInput;
}>;


export type ImportOrdersMutation = { __typename?: 'Mutation', importOrders: { __typename?: 'ImportOrdersPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, orders?: Array<{ __typename?: 'ImportOrderPayload', orderId: string, orderNumber?: string | null, failedStep?: Types.ImportOrderStep | null, rollbackFailed: boolean, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null } };

export type PlaceOrderHoldMutationVariables = Types.Exact<{
  input: Types.PlaceOrderHoldInput;
}>;


export type PlaceOrderHoldMutation = { __typename?: 'Mutation', placeOrderHold: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };

export type ReleaseOrderHoldMutationVariables = Types.Exact<{
  input: Types.ReleaseOrderHoldInput;
}>;


export type ReleaseOrderHoldMutation = { __typename?: 'Mutation', releaseOrderHold: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null } };


export const InitializeOrderDocument = new TypedDocumentString(`
    mutation InitializeOrder($input: InitializeOrderInput!) {
  initializeOrder(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const DeleteOrderDocument = new TypedDocumentString(`
    mutation DeleteOrder($input: DeleteOrderInput!) {
  deleteOrder(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const CreditExistingOrderDocument = new TypedDocumentString(`
    mutation CreditExistingOrder($input: CreditExistingOrderInput!) {
  creditExistingOrder(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
    stageResult {
      outcome
      orderId
      stages {
        stage
        status
      }
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RecordOrderDepositDocument = new TypedDocumentString(`
    mutation RecordOrderDeposit($input: RecordOrderDepositInput!) {
  recordOrderDeposit(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const EditOrderDocument = new TypedDocumentString(`
    mutation EditOrder($input: EditOrderInput!) {
  editOrder(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const AddOrderFlatChargeDocument = new TypedDocumentString(`
    mutation AddOrderFlatCharge($input: AddOrderFlatChargeInput!) {
  addOrderFlatCharge(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const EditOrderFlatChargeDocument = new TypedDocumentString(`
    mutation EditOrderFlatCharge($input: EditOrderFlatChargeInput!) {
  editOrderFlatCharge(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RemoveOrderFlatChargeDocument = new TypedDocumentString(`
    mutation RemoveOrderFlatCharge($input: RemoveOrderFlatChargeInput!) {
  removeOrderFlatCharge(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderQuoteDetailsDocument = new TypedDocumentString(`
    mutation SetOrderQuoteDetails($input: SetOrderQuoteDetailsInput!) {
  setOrderQuoteDetails(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderQuoteDetails
    }
  }
}
    fragment OrderQuoteDetails on OrderStateData {
  orderId
  status
  quoteValidUntil
  followUp {
    ...OrderQuoteFollowUp
  }
}
fragment OrderQuoteFollowUp on OrderQuoteFollowUpData {
  on
  note
  assignee
  done
  setBy
  setAt
}`);
export const SetOrderShipFromSiteDocument = new TypedDocumentString(`
    mutation SetOrderShipFromSite($input: SetOrderShipFromSiteInput!) {
  setOrderShipFromSite(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderPlannedShipDateDocument = new TypedDocumentString(`
    mutation SetOrderPlannedShipDate($input: SetOrderPlannedShipDateInput!) {
  setOrderPlannedShipDate(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderContainerDocument = new TypedDocumentString(`
    mutation SetOrderContainer($input: SetOrderContainerInput!) {
  setOrderContainer(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const AddLineItemsDocument = new TypedDocumentString(`
    mutation AddLineItems($input: AddLineItemsInput!) {
  addLineItems(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const AddLineItemsWithPricingDocument = new TypedDocumentString(`
    mutation AddLineItemsWithPricing($input: AddLineItemsWithPricingInput!) {
  addLineItemsWithPricing(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateLineItemDocument = new TypedDocumentString(`
    mutation UpdateLineItem($input: UpdateLineItemInput!) {
  updateLineItem(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetLineItemShippingUomDocument = new TypedDocumentString(`
    mutation SetLineItemShippingUom($input: SetLineItemShippingUomInput!) {
  setLineItemShippingUom(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RepriceOrderLineDocument = new TypedDocumentString(`
    mutation RepriceOrderLine($input: RepriceOrderLineInput!) {
  repriceOrderLine(input: $input) {
    errors {
      code
      message
    }
    lineItem {
      ...LineItem
    }
    order {
      ...OrderDetails
    }
    outcome
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RepriceOrderDocument = new TypedDocumentString(`
    mutation RepriceOrder($input: RepriceOrderInput!) {
  repriceOrder(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
    repricedLineCount
    skippedOverrideLineCount
    unchangedLineCount
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetLineItemCustomerItemDocument = new TypedDocumentString(`
    mutation SetLineItemCustomerItem($input: SetLineItemCustomerItemInput!) {
  setLineItemCustomerItem(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetLineItemOverridePriceDocument = new TypedDocumentString(`
    mutation SetLineItemOverridePrice($input: SetLineItemOverridePriceInput!) {
  setLineItemOverridePrice(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RemoveLineItemDocument = new TypedDocumentString(`
    mutation RemoveLineItem($input: RemoveLineItemInput!) {
  removeLineItem(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateOrderContactDocument = new TypedDocumentString(`
    mutation UpdateOrderContact($input: UpdateOrderContactInput!) {
  updateOrderContact(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateOrderStatusDocument = new TypedDocumentString(`
    mutation UpdateOrderStatus($input: UpdateOrderStatusInput!) {
  updateOrderStatus(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UnshipOrderDocument = new TypedDocumentString(`
    mutation UnshipOrder($input: UnshipOrderInput!) {
  unshipOrder(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const ResetOrderSyncStatusDocument = new TypedDocumentString(`
    mutation ResetOrderSyncStatus($input: ResetSyncStatusInput!) {
  resetOrderSyncStatus(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateSalesPersonDocument = new TypedDocumentString(`
    mutation UpdateSalesPerson($input: UpdateSalesPersonInput!) {
  updateSalesPerson(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateAndGetNextOrderNumberDocument = new TypedDocumentString(`
    mutation UpdateAndGetNextOrderNumber {
  updateAndGetNextOrderNumber {
    nextOrderNumber
  }
}
    `);
export const UpdateAcknowledgedQuantityDocument = new TypedDocumentString(`
    mutation UpdateAcknowledgedQuantity($input: UpdateAcknowledgedQuantityItemsInput!) {
  updateAcknowledgedQuantity(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const CorrectAcknowledgedQuantityDocument = new TypedDocumentString(`
    mutation CorrectAcknowledgedQuantity($input: CorrectAcknowledgedQuantityItemsInput!) {
  correctAcknowledgedQuantity(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateShippedQuantityDocument = new TypedDocumentString(`
    mutation UpdateShippedQuantity($input: UpdateShippedQuantityItemsInput!) {
  updateShippedQuantity(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const AllocateLineItemsDocument = new TypedDocumentString(`
    mutation AllocateLineItems($input: AllocateLineItemsInput!) {
  allocateLineItems(input: $input) {
    errors {
      code
      message
    }
    warnings {
      ...OverAllocationWarning
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
fragment OverAllocationWarning on OverAllocationWarningData {
  itemId
  locationId
  grade
  requestedQuantity
  availableQuantity
}`);
export const BulkAllocateOrdersDocument = new TypedDocumentString(`
    mutation BulkAllocateOrders($input: BulkAllocateOrdersInput!) {
  bulkAllocateOrders(input: $input) {
    errors {
      code
      message
    }
    results {
      ...BulkAllocateOrderResult
    }
  }
}
    fragment OverAllocationWarning on OverAllocationWarningData {
  itemId
  locationId
  grade
  requestedQuantity
  availableQuantity
}
fragment BulkAllocateOrderResult on BulkAllocateOrderResult {
  orderId
  outcome
  linesAllocated
  skipReason
  message
  shortfalls {
    ...BulkAllocateLineShortfall
  }
  skippedLines {
    ...BulkAllocateSkippedLine
  }
  warnings {
    ...OverAllocationWarning
  }
}
fragment BulkAllocateLineShortfall on BulkAllocateLineShortfall {
  lineItemId
  itemId
  orderedQuantity
  allocatedQuantity
  shortByQuantity
  shippingUomLabel
  orderedUnits
  allocatedUnits
  shortByUnits
}
fragment BulkAllocateSkippedLine on BulkAllocateSkippedLine {
  lineItemId
  itemId
  reason
}`);
export const RemoveLineItemAllocationsDocument = new TypedDocumentString(`
    mutation RemoveLineItemAllocations($input: RemoveLineItemAllocationsInput!) {
  removeLineItemAllocations(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateLineItemContextNoteDocument = new TypedDocumentString(`
    mutation UpdateLineItemContextNote($input: UpdateLineItemContextNoteInput!) {
  updateLineItemContextNote(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateOrderSendOrderEmailsDocument = new TypedDocumentString(`
    mutation UpdateOrderSendOrderEmails($input: UpdateOrderSendOrderEmailsInput!) {
  updateOrderSendOrderEmails(input: $input) {
    order {
      ...OrderDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateOrderSendInvoiceEmailsDocument = new TypedDocumentString(`
    mutation UpdateOrderSendInvoiceEmails($input: UpdateOrderSendInvoiceEmailsInput!) {
  updateOrderSendInvoiceEmails(input: $input) {
    order {
      ...OrderDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const UpdateOrderRouteDocument = new TypedDocumentString(`
    mutation UpdateOrderRoute($input: UpdateRouteInput!) {
  updateOrderRoute(input: $input) {
    order {
      ...OrderDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const CorrectOrderDocument = new TypedDocumentString(`
    mutation CorrectOrder($input: CorrectOrderInput!) {
  correctOrder(input: $input) {
    order {
      ...OrderDetails
    }
    creditOrder {
      ...OrderDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const AddOrderLineUpgradeDocument = new TypedDocumentString(`
    mutation AddOrderLineUpgrade($input: AddOrderLineUpgradeInput!) {
  addOrderLineUpgrade(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RemoveOrderLineUpgradeDocument = new TypedDocumentString(`
    mutation RemoveOrderLineUpgrade($input: RemoveOrderLineUpgradeInput!) {
  removeOrderLineUpgrade(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const OverrideOrderLineUpgradePricingDocument = new TypedDocumentString(`
    mutation OverrideOrderLineUpgradePricing($input: OverrideOrderLineUpgradePricingInput!) {
  overrideOrderLineUpgradePricing(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderNoteDocument = new TypedDocumentString(`
    mutation SetOrderNote($input: SetOrderNoteInput!) {
  setOrderNote(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const ClearOrderNoteDocument = new TypedDocumentString(`
    mutation ClearOrderNote($input: ClearOrderNoteInput!) {
  clearOrderNote(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderNoTaxDocument = new TypedDocumentString(`
    mutation SetOrderNoTax($input: SetOrderNoTaxInput!) {
  setOrderNoTax(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const ClearOrderNoTaxDocument = new TypedDocumentString(`
    mutation ClearOrderNoTax($input: ClearOrderNoTaxInput!) {
  clearOrderNoTax(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const SetOrderDropShipDestinationDocument = new TypedDocumentString(`
    mutation SetOrderDropShipDestination($input: SetOrderDropShipDestinationInput!) {
  setOrderDropShipDestination(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const ClearOrderDropShipDestinationDocument = new TypedDocumentString(`
    mutation ClearOrderDropShipDestination($input: ClearOrderDropShipDestinationInput!) {
  clearOrderDropShipDestination(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const RefreshOrderTaxEstimateDocument = new TypedDocumentString(`
    mutation RefreshOrderTaxEstimate($input: RefreshOrderTaxEstimateInput!) {
  refreshOrderTaxEstimate(input: $input) {
    estimate {
      ...OrderTaxEstimateSummary
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}`);
export const ImportOrdersDocument = new TypedDocumentString(`
    mutation ImportOrders($input: ImportOrdersInput!) {
  importOrders(input: $input) {
    errors {
      code
      message
    }
    orders {
      orderId
      orderNumber
      failedStep
      rollbackFailed
      errors {
        code
        message
      }
    }
  }
}
    `);
export const PlaceOrderHoldDocument = new TypedDocumentString(`
    mutation PlaceOrderHold($input: PlaceOrderHoldInput!) {
  placeOrderHold(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
export const ReleaseOrderHoldDocument = new TypedDocumentString(`
    mutation ReleaseOrderHold($input: ReleaseOrderHoldInput!) {
  releaseOrderHold(input: $input) {
    errors {
      code
      message
    }
    order {
      ...OrderDetails
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    InitializeOrder: build.mutation<InitializeOrderMutation, InitializeOrderMutationVariables>({
      query: (variables) => ({ document: InitializeOrderDocument, variables })
    }),
    DeleteOrder: build.mutation<DeleteOrderMutation, DeleteOrderMutationVariables>({
      query: (variables) => ({ document: DeleteOrderDocument, variables })
    }),
    CreditExistingOrder: build.mutation<CreditExistingOrderMutation, CreditExistingOrderMutationVariables>({
      query: (variables) => ({ document: CreditExistingOrderDocument, variables })
    }),
    RecordOrderDeposit: build.mutation<RecordOrderDepositMutation, RecordOrderDepositMutationVariables>({
      query: (variables) => ({ document: RecordOrderDepositDocument, variables })
    }),
    EditOrder: build.mutation<EditOrderMutation, EditOrderMutationVariables>({
      query: (variables) => ({ document: EditOrderDocument, variables })
    }),
    AddOrderFlatCharge: build.mutation<AddOrderFlatChargeMutation, AddOrderFlatChargeMutationVariables>({
      query: (variables) => ({ document: AddOrderFlatChargeDocument, variables })
    }),
    EditOrderFlatCharge: build.mutation<EditOrderFlatChargeMutation, EditOrderFlatChargeMutationVariables>({
      query: (variables) => ({ document: EditOrderFlatChargeDocument, variables })
    }),
    RemoveOrderFlatCharge: build.mutation<RemoveOrderFlatChargeMutation, RemoveOrderFlatChargeMutationVariables>({
      query: (variables) => ({ document: RemoveOrderFlatChargeDocument, variables })
    }),
    SetOrderQuoteDetails: build.mutation<SetOrderQuoteDetailsMutation, SetOrderQuoteDetailsMutationVariables>({
      query: (variables) => ({ document: SetOrderQuoteDetailsDocument, variables })
    }),
    SetOrderShipFromSite: build.mutation<SetOrderShipFromSiteMutation, SetOrderShipFromSiteMutationVariables>({
      query: (variables) => ({ document: SetOrderShipFromSiteDocument, variables })
    }),
    SetOrderPlannedShipDate: build.mutation<SetOrderPlannedShipDateMutation, SetOrderPlannedShipDateMutationVariables>({
      query: (variables) => ({ document: SetOrderPlannedShipDateDocument, variables })
    }),
    SetOrderContainer: build.mutation<SetOrderContainerMutation, SetOrderContainerMutationVariables>({
      query: (variables) => ({ document: SetOrderContainerDocument, variables })
    }),
    AddLineItems: build.mutation<AddLineItemsMutation, AddLineItemsMutationVariables>({
      query: (variables) => ({ document: AddLineItemsDocument, variables })
    }),
    AddLineItemsWithPricing: build.mutation<AddLineItemsWithPricingMutation, AddLineItemsWithPricingMutationVariables>({
      query: (variables) => ({ document: AddLineItemsWithPricingDocument, variables })
    }),
    UpdateLineItem: build.mutation<UpdateLineItemMutation, UpdateLineItemMutationVariables>({
      query: (variables) => ({ document: UpdateLineItemDocument, variables })
    }),
    SetLineItemShippingUom: build.mutation<SetLineItemShippingUomMutation, SetLineItemShippingUomMutationVariables>({
      query: (variables) => ({ document: SetLineItemShippingUomDocument, variables })
    }),
    RepriceOrderLine: build.mutation<RepriceOrderLineMutation, RepriceOrderLineMutationVariables>({
      query: (variables) => ({ document: RepriceOrderLineDocument, variables })
    }),
    RepriceOrder: build.mutation<RepriceOrderMutation, RepriceOrderMutationVariables>({
      query: (variables) => ({ document: RepriceOrderDocument, variables })
    }),
    SetLineItemCustomerItem: build.mutation<SetLineItemCustomerItemMutation, SetLineItemCustomerItemMutationVariables>({
      query: (variables) => ({ document: SetLineItemCustomerItemDocument, variables })
    }),
    SetLineItemOverridePrice: build.mutation<SetLineItemOverridePriceMutation, SetLineItemOverridePriceMutationVariables>({
      query: (variables) => ({ document: SetLineItemOverridePriceDocument, variables })
    }),
    RemoveLineItem: build.mutation<RemoveLineItemMutation, RemoveLineItemMutationVariables>({
      query: (variables) => ({ document: RemoveLineItemDocument, variables })
    }),
    UpdateOrderContact: build.mutation<UpdateOrderContactMutation, UpdateOrderContactMutationVariables>({
      query: (variables) => ({ document: UpdateOrderContactDocument, variables })
    }),
    UpdateOrderStatus: build.mutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>({
      query: (variables) => ({ document: UpdateOrderStatusDocument, variables })
    }),
    UnshipOrder: build.mutation<UnshipOrderMutation, UnshipOrderMutationVariables>({
      query: (variables) => ({ document: UnshipOrderDocument, variables })
    }),
    ResetOrderSyncStatus: build.mutation<ResetOrderSyncStatusMutation, ResetOrderSyncStatusMutationVariables>({
      query: (variables) => ({ document: ResetOrderSyncStatusDocument, variables })
    }),
    UpdateSalesPerson: build.mutation<UpdateSalesPersonMutation, UpdateSalesPersonMutationVariables>({
      query: (variables) => ({ document: UpdateSalesPersonDocument, variables })
    }),
    UpdateAndGetNextOrderNumber: build.mutation<UpdateAndGetNextOrderNumberMutation, UpdateAndGetNextOrderNumberMutationVariables | void>({
      query: (variables) => ({ document: UpdateAndGetNextOrderNumberDocument, variables })
    }),
    UpdateAcknowledgedQuantity: build.mutation<UpdateAcknowledgedQuantityMutation, UpdateAcknowledgedQuantityMutationVariables>({
      query: (variables) => ({ document: UpdateAcknowledgedQuantityDocument, variables })
    }),
    CorrectAcknowledgedQuantity: build.mutation<CorrectAcknowledgedQuantityMutation, CorrectAcknowledgedQuantityMutationVariables>({
      query: (variables) => ({ document: CorrectAcknowledgedQuantityDocument, variables })
    }),
    UpdateShippedQuantity: build.mutation<UpdateShippedQuantityMutation, UpdateShippedQuantityMutationVariables>({
      query: (variables) => ({ document: UpdateShippedQuantityDocument, variables })
    }),
    AllocateLineItems: build.mutation<AllocateLineItemsMutation, AllocateLineItemsMutationVariables>({
      query: (variables) => ({ document: AllocateLineItemsDocument, variables })
    }),
    BulkAllocateOrders: build.mutation<BulkAllocateOrdersMutation, BulkAllocateOrdersMutationVariables>({
      query: (variables) => ({ document: BulkAllocateOrdersDocument, variables })
    }),
    RemoveLineItemAllocations: build.mutation<RemoveLineItemAllocationsMutation, RemoveLineItemAllocationsMutationVariables>({
      query: (variables) => ({ document: RemoveLineItemAllocationsDocument, variables })
    }),
    UpdateLineItemContextNote: build.mutation<UpdateLineItemContextNoteMutation, UpdateLineItemContextNoteMutationVariables>({
      query: (variables) => ({ document: UpdateLineItemContextNoteDocument, variables })
    }),
    UpdateOrderSendOrderEmails: build.mutation<UpdateOrderSendOrderEmailsMutation, UpdateOrderSendOrderEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateOrderSendOrderEmailsDocument, variables })
    }),
    UpdateOrderSendInvoiceEmails: build.mutation<UpdateOrderSendInvoiceEmailsMutation, UpdateOrderSendInvoiceEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateOrderSendInvoiceEmailsDocument, variables })
    }),
    UpdateOrderRoute: build.mutation<UpdateOrderRouteMutation, UpdateOrderRouteMutationVariables>({
      query: (variables) => ({ document: UpdateOrderRouteDocument, variables })
    }),
    CorrectOrder: build.mutation<CorrectOrderMutation, CorrectOrderMutationVariables>({
      query: (variables) => ({ document: CorrectOrderDocument, variables })
    }),
    AddOrderLineUpgrade: build.mutation<AddOrderLineUpgradeMutation, AddOrderLineUpgradeMutationVariables>({
      query: (variables) => ({ document: AddOrderLineUpgradeDocument, variables })
    }),
    RemoveOrderLineUpgrade: build.mutation<RemoveOrderLineUpgradeMutation, RemoveOrderLineUpgradeMutationVariables>({
      query: (variables) => ({ document: RemoveOrderLineUpgradeDocument, variables })
    }),
    OverrideOrderLineUpgradePricing: build.mutation<OverrideOrderLineUpgradePricingMutation, OverrideOrderLineUpgradePricingMutationVariables>({
      query: (variables) => ({ document: OverrideOrderLineUpgradePricingDocument, variables })
    }),
    SetOrderNote: build.mutation<SetOrderNoteMutation, SetOrderNoteMutationVariables>({
      query: (variables) => ({ document: SetOrderNoteDocument, variables })
    }),
    ClearOrderNote: build.mutation<ClearOrderNoteMutation, ClearOrderNoteMutationVariables>({
      query: (variables) => ({ document: ClearOrderNoteDocument, variables })
    }),
    SetOrderNoTax: build.mutation<SetOrderNoTaxMutation, SetOrderNoTaxMutationVariables>({
      query: (variables) => ({ document: SetOrderNoTaxDocument, variables })
    }),
    ClearOrderNoTax: build.mutation<ClearOrderNoTaxMutation, ClearOrderNoTaxMutationVariables>({
      query: (variables) => ({ document: ClearOrderNoTaxDocument, variables })
    }),
    SetOrderDropShipDestination: build.mutation<SetOrderDropShipDestinationMutation, SetOrderDropShipDestinationMutationVariables>({
      query: (variables) => ({ document: SetOrderDropShipDestinationDocument, variables })
    }),
    ClearOrderDropShipDestination: build.mutation<ClearOrderDropShipDestinationMutation, ClearOrderDropShipDestinationMutationVariables>({
      query: (variables) => ({ document: ClearOrderDropShipDestinationDocument, variables })
    }),
    RefreshOrderTaxEstimate: build.mutation<RefreshOrderTaxEstimateMutation, RefreshOrderTaxEstimateMutationVariables>({
      query: (variables) => ({ document: RefreshOrderTaxEstimateDocument, variables })
    }),
    ImportOrders: build.mutation<ImportOrdersMutation, ImportOrdersMutationVariables>({
      query: (variables) => ({ document: ImportOrdersDocument, variables })
    }),
    PlaceOrderHold: build.mutation<PlaceOrderHoldMutation, PlaceOrderHoldMutationVariables>({
      query: (variables) => ({ document: PlaceOrderHoldDocument, variables })
    }),
    ReleaseOrderHold: build.mutation<ReleaseOrderHoldMutation, ReleaseOrderHoldMutationVariables>({
      query: (variables) => ({ document: ReleaseOrderHoldDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useInitializeOrderMutation, useDeleteOrderMutation, useCreditExistingOrderMutation, useRecordOrderDepositMutation, useEditOrderMutation, useAddOrderFlatChargeMutation, useEditOrderFlatChargeMutation, useRemoveOrderFlatChargeMutation, useSetOrderQuoteDetailsMutation, useSetOrderShipFromSiteMutation, useSetOrderPlannedShipDateMutation, useSetOrderContainerMutation, useAddLineItemsMutation, useAddLineItemsWithPricingMutation, useUpdateLineItemMutation, useSetLineItemShippingUomMutation, useRepriceOrderLineMutation, useRepriceOrderMutation, useSetLineItemCustomerItemMutation, useSetLineItemOverridePriceMutation, useRemoveLineItemMutation, useUpdateOrderContactMutation, useUpdateOrderStatusMutation, useUnshipOrderMutation, useResetOrderSyncStatusMutation, useUpdateSalesPersonMutation, useUpdateAndGetNextOrderNumberMutation, useUpdateAcknowledgedQuantityMutation, useCorrectAcknowledgedQuantityMutation, useUpdateShippedQuantityMutation, useAllocateLineItemsMutation, useBulkAllocateOrdersMutation, useRemoveLineItemAllocationsMutation, useUpdateLineItemContextNoteMutation, useUpdateOrderSendOrderEmailsMutation, useUpdateOrderSendInvoiceEmailsMutation, useUpdateOrderRouteMutation, useCorrectOrderMutation, useAddOrderLineUpgradeMutation, useRemoveOrderLineUpgradeMutation, useOverrideOrderLineUpgradePricingMutation, useSetOrderNoteMutation, useClearOrderNoteMutation, useSetOrderNoTaxMutation, useClearOrderNoTaxMutation, useSetOrderDropShipDestinationMutation, useClearOrderDropShipDestinationMutation, useRefreshOrderTaxEstimateMutation, useImportOrdersMutation, usePlaceOrderHoldMutation, useReleaseOrderHoldMutation } = injectedRtkApi;
